import { AppBar, Toolbar, Button } from "@mui/material"
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos"
import { useNavigate } from "react-router-dom"
import useAppStore from "store/app"
import { useTheme } from "@mui/material/styles"
import RtlIconWrapper from "../RtlIconWrapper"
const BackButton = (props) => {
  const { text, callback } = props
  const t = useAppStore((state) => state.translations)
  const theme = useTheme()
  const navigate = useNavigate()

  const handleGoBack = () => {
    if (typeof callback === "function") callback()
    navigate(-1)
  }

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{ top: 0, bottom: "auto", backgroundColor: "bg.light", mb: 1 }}
    >
      <Toolbar disableGutters variant="dense">
        <Button
          startIcon={
            <RtlIconWrapper>
              <ArrowBackIosIcon />
            </RtlIconWrapper>
          }
          disableElevation
          sx={{
            textTransform: "none",
            whiteSpace: "nowrap",
            fontSize: theme.direction === "rtl" ? "20px" : "17px",
            px: 2,
          }}
          onClick={handleGoBack}
        >
          {text || t?.data?.pages?.home?.back}
        </Button>
      </Toolbar>
    </AppBar>
  )
}

export default BackButton
